var React = require('react');

function LogoTablet (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.4057 0H3.48113C2.55788 0 1.67244 0.358603 1.0196 0.99692C0.366761 1.63524 0 2.50098 0 3.4037L0 28.1175L24.8069 3.82546C20.0165 11.4912 22.703 19.2383 26.5474 22.5458C22.703 19.2383 16.104 18.7203 12.184 20.844C9.4596 22.3238 8.30931 24.6546 8.70283 28.0805C9.14176 31.906 13.0542 34 15.6651 34H17.4057C21.8766 33.796 26.0953 31.9159 29.1856 28.7501C32.2758 25.5843 34 21.3762 34 17C34 12.6237 32.2758 8.41569 29.1856 5.24992C26.0953 2.08414 21.8766 0.203988 17.4057 0Z","fill":"#262626"}));
}

LogoTablet.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34","fill":"none"};

module.exports = LogoTablet;

LogoTablet.default = LogoTablet;
